import { extendTheme } from '@chakra-ui/react'
import { heading } from './components/heading'
import { text } from './components/text'
import { fonts } from './fonts'
import { colors } from './styles'
import { CardComponent } from './additions/card/Card'
import { CardBodyComponent } from './additions/card/CardBody'
import { CardHeaderComponent } from './additions/card/CardHeader'
import { LinkComponent } from './additions/link/Link'
import { ToastComponent } from './additions/toast/Toast'
import { button } from './components/button'
import { input } from './components/input'

export const theme = extendTheme({
  styles: {
    global: () => ({
      body: {
        bg: '#fff',
      },
    }),
  },
  colors,
  fonts,
  breakpoints: {
    sm: '320px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
  },
  components: {
    Heading: heading,
    Text: text,
    Button: button,
    Card: CardComponent,
    CardBody: CardBodyComponent,
    CardHeader: CardHeaderComponent,
    Link: LinkComponent,
    Toast: ToastComponent,
    Box: input,
  },
})
